import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=6fd37bd6&"
import script from "./EditVendor.vue?vue&type=script&lang=js&"
export * from "./EditVendor.vue?vue&type=script&lang=js&"
import style0 from "./EditVendor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditVendor.vue"
export default component.exports